import React from 'react';
import {connect} from 'react-redux';
import { withTranslation } from 'react-i18next';
import SearchBar from "../../../../../../components/search-bar";
import {upperCaseFirstLetter} from "../../../../../../utils";
import {findUsers} from "../../../../../../../actions/usersListActions";
import {enteredCollaboratorSearchValue} from "../../../../../../../actions/sharingDetailsActions";

class UserListSearch extends React.Component {

	constructor(props){
		super(props);

		this.changeHandler = this.changeHandler.bind(this);
	}

	changeHandler(e){

		this.props.enteredCollaboratorSearchValue(e.target.value);

        if(this.props.usersListFilteredStatus){
            if(this.props.usersListFilteredLicense){
                this.props.setFindUsers(this.props.usersListFilteredStatus, this.props.usersListFilteredLicense)
            } else {
                this.props.setFindUsers(this.props.usersListFilteredStatus)
            }
        } else {
            if(this.props.usersListFilteredLicense){
                this.props.setFindUsers(null, this.props.usersListFilteredLicense)
            } else {
                this.props.setFindUsers()
            }
        }


	}

	render() {
		return (
			<SearchBar
				id="searchCollaboratorUserList"
				label="Search a collaborator"
				title={this.props.t("popupSharingSearchCollaborators")}
				srOnly={true}
				onChange={this.changeHandler}
				placeholder={upperCaseFirstLetter(this.props.t("popupSharingSearchCollaborators"))}
				width={225}
			/>
		)
	}
}

const mapStateToProps = (state) => {
    return {
        usersListFilteredStatus: state.usersListReducer.usersListFilteredStatus,
        usersListFilteredLicense: state.usersListReducer.usersListFilteredLicense
    };
};

const mapDispatchToProps = (dispatch) => {
	return {
		setFindUsers : (labelId, pageSize) => {
			dispatch(findUsers(labelId, pageSize))
		},
		enteredCollaboratorSearchValue  : (string) => {
			dispatch(enteredCollaboratorSearchValue(string))
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(UserListSearch));